var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      staticStyle: { "text-align": "center" },
      attrs: {
        color: _vm.snackColor,
        timeout: _vm.snackTimeout,
        top: "",
        value: _vm.snackbarValue,
      },
      on: {
        change: function ($event) {
          return _vm.$emit("update:snackbar", $event)
        },
      },
    },
    [
      _vm._v("\n  " + _vm._s(_vm.snackMessage) + "\n  "),
      _c(
        "v-btn",
        {
          attrs: { dark: "", flat: "" },
          nativeOn: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.$emit("update:snackbar", false)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }